import './all.sass'

import { graphql, useStaticQuery } from 'gatsby'

import Footer from './Footer'
import Helmet from 'react-helmet'
import Navbar from './Navbar'
// import PropTypes from "prop-types";
import React from 'react'

// import useSiteMetadata from "./SiteMetadata";
// import { withPrefix } from "gatsby";

const TemplateWrapper = ({ children }) => {
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query MenuQuery {
        allMarkdownRemark(filter: { fields: { slug: { regex: "/menu/" } } }) {
          edges {
            node {
              fields {
                slug
              }
              frontmatter {
                title
                showCategory
                category {
                  categoryName
                }
              }
            }
          }
        }
      }
    `
  )
  // const { allMarkdownRemark } = data;
  const submenu = allMarkdownRemark.edges.map(e => ({
    title: e.node.frontmatter.title,
    url: e.node.fields.slug,
    haveCategory: e.node.frontmatter.showCategory,
    categories: e.node.frontmatter.category,
  }))
  const menu = [
    {
      name: 'Caffe Bene',
      url: '/',
      hoverable: true,
      submenu: [
        {
          title: 'Brand Story',
          url: '/about',
        },
        {
          title: 'Coffee Story',
          url: '/principle',
        },
      ],
    },
    {
      name: 'Menu',
      url: '/menu/beverages',
      hoverable: true,
      megaMenu: true,
      submenu: submenu,
    },
    {
      name: 'Outlets',
      url: '/outlets',
      hoverable: false,
    },
    {
      name: 'Opportunities',
      url: '/opportunities',
      hoverable: false,
    },
    {
      name: 'Careers',
      url: '/careers',
      hoverable: false,
    },
  ]

  // const { title, description } = useSiteMetadata();

  return (
    <div>
      <Helmet title="Caffebene" />
      <Navbar logo="/img/logo.png" items={menu} />
      <div>{children}</div>
      <Footer />
    </div>
  )
}

// TemplateWrapper.propTypes = {
//   children: PropTypes.func,
//   data: PropTypes.object
// };

export default TemplateWrapper

// export const MenuQuery = graphql`
//   query MenuQuery {
//     allMarkdownRemark(filter: { fields: { slug: { regex: "/menu/" } } }) {
//       edges {
//         node {
//           fields {
//             slug
//           }
//           frontmatter {
//             title
//             showCategory
//             category {
//               categoryName
//             }
//           }
//         }
//       }
//     }
//   }
// `;
